import { combineReducers } from 'redux'
import app from './app-reducer'
import user from './user-reducer'
import item from './item-reducer'

const combinedReducers = combineReducers({
  app,
  user,
  item,
})

export default combinedReducers
